import { render, staticRenderFns } from "./checkbox_v.vue?vue&type=template&id=fdf9c78e&scoped=true&"
import script from "./checkbox_v.vue?vue&type=script&lang=js&"
export * from "./checkbox_v.vue?vue&type=script&lang=js&"
import style0 from "./checkbox_v.vue?vue&type=style&index=0&id=fdf9c78e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf9c78e",
  null
  
)

export default component.exports